import { TextFieldProps } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  DatePicker,
  DatePickerProps,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import React from "react";

export interface CustomDatePickerProps
  extends Omit<DatePickerProps<any, boolean>, "renderInput"> {
  label?: string;
  error?: boolean;
  helperText?: React.ReactNode;
  fullWidth?: boolean;
  required?: boolean;
  sx?: any;
}

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
  label,
  error,
  helperText,
  fullWidth = true,
  required,
  sx,
  ...props
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        label={label}
        {...props}
        slotProps={{
          textField: {
            fullWidth,
            required,
            error,
            helperText,
            size: "small",
            sx: {
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
              },
              ...sx,
            },
          } as TextFieldProps,
        }}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
